<template>
  <div class="title-comp">
    <span class="stand-ion"></span>
    <span class="title-text">{{ title }}</span>
    <em v-if="showClose" class="el-icon-close close" @click="$emit('close')"></em>
  </div>
</template>

<script>
export default {
  name: 'TitleComp',
  props: {
    title: {
      type: String,
      default: '这是一个标题'
    },
    showClose: {
      type: Boolean,
      dafault: false
    }
  }
};
</script>

<style lang="scss">
.title-comp {
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
  position: relative;
  .stand-ion {
    display: inline-block;
    background-color: #f5ff54;
    height: 10px;
    width: 4px;
    margin-right: 5px;
  }
  .title-text {
    font-size: 20px;
    font-weight: bold;
    color: #b9fffc;
  }
  &:hover {
    .close {
      display: inline-block;
      position: absolute;
      margin-left: 2px;
      top: 0;
    }
  }
  .close {
    display: none;
    cursor: pointer;
  }
}
</style>
